module.exports = {
      id: "authorwhite-usage",
      viewBox: "0 0 30.127 24.506",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#authorwhite",
      toString: function () {
        return this.url;
      }
    }